// extracted by mini-css-extract-plugin
export var wordContainer = "_rr-0";